import React, { useState, useContext } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
const generateYearRanges = (startYear, endYear) => {
  const ranges = [];
  for (let year = startYear; year < endYear; year++) {
    ranges.push(`${year}-${year + 1}`);
  }
  return ranges;
};

const ReportFirstPage = () => {
  const [periodType, setPeriodType] = useState(""); // Initially empty
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [reportType, setReportType] = useState("");
  const { permissions } = useContext(AuthContext);
  console.log("permissions", permissions);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();

  const handleGenerate = () => {
    const formattedMonth = String(month).padStart(2, "0");

    if (reportType === "monthly-loan" && periodType === "month") {
      navigate(`/monthly-loan-report/${year}/${formattedMonth}`);
    } else if (reportType === "monthly-vfc" && periodType === "month") {
      navigate(`/monthly-vfc-report/${year}/${formattedMonth}`);
    } else if (reportType === "yearly" && periodType === "year") {
      navigate(`/half-yearly-report/${year}`);
    } else {
      alert("Please select valid options.");
    }
  };

  const handleHalfYearlyReport = () => {
    navigate("/half-yearly-report-form");
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());

  return (
    <>
      <div className="page-header">
        <h3 className="page-title">Reports</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(e) => e.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Reports
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <div className="card-body">
          {permissions.includes("AddReports") && (
            <div className="d-flex justify-content-end mb-4">
              <button
                type="button"
                className="btn btn-outline-success btn-icon-text"
                onClick={handleHalfYearlyReport}
              >
                Add Half Yearly Report
              </button>
            </div>
          )}

          <Form>
            <Row className="justify-content-center align-items-end">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Select Period</Form.Label>
                  <Form.Control
                    as="select"
                    value={periodType}
                    onChange={(e) => {
                      setPeriodType(e.target.value);
                      setYear("");
                      setMonth("");
                      setReportType("");
                    }}
                  >
                    <option value="">-- Select Period --</option>
                    <option value="year">Half Yearly</option>
                    <option value="month">Monthly</option>
                  </Form.Control>
                </Form.Group>
              </Col>

              {periodType && (
                <>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>
                        {periodType === "year" ? "Year" : "Month"}
                      </Form.Label>
                      {periodType === "year" ? (
                        <Form.Control
                          as="select"
                          value={year}
                          onChange={(e) => {
                            setYear(e.target.value);
                            setMonth("");
                            setStartDate("");
                            setEndDate("");
                          }}
                          disabled={startDate}
                        >
                          <option value="">Select Year</option>
                          {yearRanges.map((yr) => (
                            <option key={yr} value={yr}>
                              {yr}
                            </option>
                          ))}
                        </Form.Control>
                      ) : (
                        <Form.Control
                          type="month"
                          value={
                            month && year
                              ? `${year}-${String(month).padStart(2, "0")}`
                              : ""
                          }
                          onChange={(e) => {
                            const [yr, mth] = e.target.value.split("-");
                            setMonth(parseInt(mth));
                            setYear(parseInt(yr));
                            setStartDate("");
                            setEndDate("");
                          }}
                          disabled={startDate}
                        />
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Report Type</Form.Label>
                      <Form.Control
                        as="select"
                        value={reportType}
                        onChange={(e) => setReportType(e.target.value)}
                      >
                        <option value="">Select Report</option>
                        {periodType === "month" && (
                          <>
                            <option value="monthly-loan">
                              Monthly Loan Report
                            </option>
                            <option value="monthly-vfc">
                              Monthly Report of Functioning VFC
                            </option>
                          </>
                        )}
                        {periodType === "year" && (
                          <option value="yearly">Half Yearly Report</option>
                        )}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Button
                      className="w-100 mt-3"
                      onClick={handleGenerate}
                      disabled={
                        !reportType ||
                        (periodType === "month" && (!year || !month)) ||
                        (periodType === "year" && !year)
                      }
                    >
                      Generate
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ReportFirstPage;
